<template>
  <div
    class="dataBaseDetail"
    v-if="this.language == 'eng'"
    style="font-family: 'Times New Roman', Times, serif"
  >
    <Pic-top></Pic-top>
    <div class="dataBaseDetailTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">Home</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="exhibitionSale"
            >Regong Art Exhibition and Sales</router-link
          >
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ item.englishName }}</span>
        </div>
      </div>
    </div>
    <Common-detail></Common-detail>
    <div class="contact">
      <div class="made" @click="goExhibitionMade()">
        <img src="../../assets/exhibitionsale/user.png" alt="" />
        <div>Customized Work</div>
      </div>
      <!-- <el-popover placement="left" width="240" trigger="hover">
        <div class="tel">Contact Number：{{templeContact}}</div>
        <div class="tel">Email：{{templeEmail}}</div>
        <div class="contact" slot="reference">
        <div class="mobile" slot="reference">
          <div class="message">
            <img src="../../assets/exhibitionsale/phone.png" alt="" />
            <div>Contact art studio</div>
          </div>
        </div>
      </div>
      </el-popover> -->
    </div>
  </div>
  <div class="dataBaseDetail" v-else-if="this.language == 'en'">
    <Pic-top></Pic-top>
    <div class="dataBaseDetailTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">ངོ་བྱང་།</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="exhibitionSale"
            >རེབ་གོ་ང་སྒྱུ་རྩལ་འགྲེམ་འཚོང་།</router-link
          >
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ item.zangName }}</span>
        </div>
      </div>
    </div>
    <Common-detail></Common-detail>
    <div class="contact">
      <div class="made" @click="goExhibitionMade()">
        <img src="../../assets/exhibitionsale/user.png" alt />
        <div>གཏན་ཁེལ།</div>
      </div>
      <!-- <el-popover placement="left" width="240" trigger="hover">
        <div class="tel">འབྲེལ་གཏུགས་ཨང་གྲངས།：{{templeContact}}</div>
        <div class="tel">སྦྲགས་ཡིག：{{templeEmail}}</div>
        <div class="contact" slot="reference">
        <div class="mobile" slot="reference">
          <div class="message">
            <img src="../../assets/exhibitionsale/phone.png" alt="" />
            <div>འབྲེལ་གཏུག</div>
          </div>
        </div>
      </div>
      </el-popover> -->
    </div>
  </div>
  <div class="dataBaseDetail" v-else>
    <Pic-top></Pic-top>
    <div class="dataBaseDetailTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">首页</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="exhibitionSale">热贡作品展销</router-link>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ item.chineseName }}</span>
        </div>
      </div>
    </div>
    <Common-detail></Common-detail>
    <div class="contact">
      <div class="made" @click="goExhibitionMade()">
        <img src="../../assets/exhibitionsale/user.png" alt="" />
        <div>作品定制</div>
      </div>
      <!-- <el-popover placement="left" width="240" trigger="hover">
        <div class="tel">联系电话：{{templeContact}}</div>
        <div class="tel">邮件：{{templeEmail}}</div>
        <div class="mobile" slot="reference">
          <div class="message">
            <img src="../../assets/exhibitionsale/phone.png" alt="" />
            <div>联系画院</div>
          </div>
        </div>
      </el-popover> -->
    </div>
  </div>
</template>
<script>
import CommonDetail from "../../components/commonDetail.vue";
import { productGet,inheritDetail } from "../../api/management.js";
import PicTop from "../../components/picsTop.vue";
export default {
  components: {
    PicTop,
    CommonDetail,
  },
  data() {
    return {
      language: this.$store.state.language,
      url: process.env.VUE_APP_WEB_URL,
      title: "",
      id: this.$route.query.id,
      item: {},
      category: null,
      templeContact:'',
      templeEmail:''
    };
  },
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
  },
  created() {
    this.getProductGet();
  },
  mounted() {
    new this.$wow.WOW().init();
    this.getPCorMobile();
  },
  methods: {
    async getProductGet() {
      const res = await productGet(this.id);
      if(res.code==1) {
        if(res.data.inheritorId) {
          this.getInheritorDetail(res.data.inheritorId);
        }
        this.item = res.data;
        // if(res.data.templeContact) {
        //   this.templeContact = res.data.templeContact;
        // }else {
        //   this.templeContact='18997193666';
        // }
        if(res.data.templeEmail) {
          this.templeEmail = res.data.templeEmail;
        }else {
          this.templeEmail='regong_art_db@163.com';
        }
      }
    },
    async getInheritorDetail(id) {
      const res = await inheritDetail(id);
      if (res.code == 1) {
        if(res.data.mobile) {
          this.templeContact = res.data.mobile;
        } else {
          this.templeContact='13327681876';
        }
      }
    },
    // 判断手机端还是PC端
    getPCorMobile() {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.width = 320;
        this.height = 380;
      } else {
        this.width = 460;
        this.height = 610;
      }
    },
    handleRouter(num) {
      this.$store.commit("changeNum", num);
      this.$router.push("/index");
    },
    //作品定制
    goExhibitionMade() {
      // console.log(this.item);
      let phone = this.templeContact
      let email = this.templeEmail
      let inheritorId = this.item.inheritorId
      let templeId = this.item.templeId
      if(this.item.inheritorChineseName=='收藏') {
        this.$router.push({path: "/exhibitionMade", query: {inheritorId: '',templeId: templeId,phone: phone,email: email}});
      } else {
        this.$router.push({path: "/exhibitionMade", query: {inheritorId: inheritorId,templeId: templeId,phone: phone,email: email}});
      }
    },
  },
};
</script>
<style lang="scss">
.dataBaseDetail {
  .line {
    line-height: 1.5;
    font-size: 16px;
    text-align: justify;
  }
  position: relative;
  background: url("../../assets/newImage/index/could_right.png") no-repeat right
    bottom;
  background-position: 100% 100%;
  background-size: 7%;
  .dataBaseDetailTop {
    position: relative;
    border-bottom: 1px solid #f4f5f6;
    .section {
      padding: 50px 0;
      font-size: 18px;
      position: relative;
      .section_left {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        z-index: 88;
        .color {
          color: #ed201a;
        }
        span {
          cursor: pointer;
        }
      }
    }
  }
  .contact {
    z-index: 99;
    color: #fff;
    position: fixed;
    right: 2%;
    bottom: 20%;
    .made,
    .mobile {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      text-align: center;
      width: 110px;
      height: 110px;
      border-radius: 100%;
      background-color: #99131a;
      font-size: 12px;
      // margin-bottom: 20px;
      box-shadow: 0 0 10px #99131a;
      border: none;
      img {
        width: 32px;
        margin-bottom: 6px;
      }
    }
  }
  .cloudright {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 240px;
  }
}
@media (max-width: 768px) {
  .dataBaseDetail {
    position: relative;
    background-size: 15%;
    margin: 0;
    padding-bottom: 1rem;
    .dataBaseDetailTop {
      background: url("../../assets/newImage/index/could_left.png") no-repeat
        top left;
      background-position: 0 50%;
      background-size: 15%;
      .section {
        padding: 0.6rem 0.2rem;
        font-size: 0.3rem;
        .section_left {
          left: 0.2rem;
        }
      }
    }
    .contact {
      z-index: 2001;
      bottom: 35%;
      right: 1%;
      .made,
      .mobile {
        width: 1.7rem;
        height: 1.7rem;
        padding: 0.2rem;
        // margin-bottom: 0.2rem;
        img {
          width: 0.4rem;
        }
        div {
          font-size: 0.2rem;
        }
      }
    }
    .cloudright {
      position: absolute;
      right: 0;
      bottom: -3%;
      width: 1.25rem;
    }
  }
}
</style>